module.exports = __webpack_public_path__ + "static/media/431246137_723472689965175_6948972200210266793_n (1).bd0e62b9.jpg";